module.exports = __webpack_public_path__ + "assets/logo.svg?82e65615aae47c5a9bc05999b7d3a2f7";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/logo.svg
// module id = 276
// module chunks = 0